import { Injectable } from "@angular/core";
@Injectable()
export class ApplicationConfig {

  static readonly PRIMARY_COLOR: string = '#5986B3';
  static readonly SECONDARY_COLOR: string = '#faa61a';

  public readonly DEFAULT_PRIMARY_COLOR: string = '#5986B3';
  public readonly DEFAULT_PRIMARY_TEXT_COLOR: string = '#ffffff';
  public readonly DEFAULT_SECONDARY_COLOR: string = '#faa61a';
  public readonly DEFAULT_SECONDARY_TEXT_COLOR: string = '#ffffff';
  public readonly DEFAULT_FONT: string = 'Roboto';
  public readonly DEFAULT_TEXT_COLOR: string = '#1c1c1c';
  public readonly DEFAULT_TITLE_TEXT_COLOR: string = '#5995B3';
  public readonly DATE_FORMAT: string = 'dd/MM/yyyy';
  public readonly DATE_TIME_FORMAT: string = 'dd/MM/yyyy, HH:mm';
  public readonly PDF_ICON_URL: string = 'assets/images/file-extensions/pdf.png';
  public readonly DEFAULT_LOGO_URL: string = 'assets/company-logo.png';
  public readonly DEFAULT_BACKGROUND_URL: string = 'assets/background.jpg';
  public readonly CHAPPS_ACCOUNT_LOGO_URL: string = 'assets/chapps-button.png';
  public readonly IMAGE_PLACEHOLDER_URL: string = 'assets/images/placeholder.png';
  public readonly AVATAR_PLACEHOLDER: string = 'assets/images/avatar_placeholder.png';
  public readonly DEFAULT_FILE_URL: string = 'assets/images/defaultFile.png';
  public readonly MAX_RESOLUTION_TO_SHOW_BACK_BUTTON: number =  1200;
  public readonly BACK_BUTTON_REGEXP_PAGES: string[] = [
    '^\\/residents\\/\\d*',
    '^\\/notifications\\/\\d*',
    '^\\/announcements\\/\\d*',
  ];
  public readonly MOMENT_DATE_FORMAT: string = 'DD/MM/YYYY';
  public readonly MOMENT_DATE_TIME_FORMAT: string = 'DD/MM/YYYY, HH:mm';
}
